import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./modules/layStore";
// 创建store对象
const store = configureStore({
  reducer: {
    counter: counterReducer,
  },
});
export default store;
